<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { dynamicTime } from 'shared/helpers/timeHelper';

import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { COMPANY_ROW_GRID } from 'dashboard/components-next/Companies/CompaniesCard/constants';

const props = defineProps({
  id: { type: Number, required: true },
  name: { type: String, default: '' },
  domain: { type: String, default: '' },
  contactsCount: { type: Number, default: 0 },
  avatarUrl: { type: String, default: '' },
  lastActivityAt: { type: [String, Number], default: null },
  createdAt: { type: [String, Number], default: null },
});

const emit = defineEmits(['showCompany']);

const { t } = useI18n();

const onClickViewDetails = () => emit('showCompany', props.id);

const displayName = computed(() => props.name || t('COMPANIES.UNNAMED'));

const avatarSource = computed(() => props.avatarUrl || null);

const contactsCountLabel = computed(() =>
  t('COMPANIES.CONTACTS_COUNT', { n: Number(props.contactsCount || 0) })
);

const formattedLastActivityAt = computed(() =>
  props.lastActivityAt ? dynamicTime(props.lastActivityAt) : ''
);

const formattedCreatedAt = computed(() =>
  props.createdAt ? dynamicTime(props.createdAt) : ''
);
</script>

<template>
  <button
    type="button"
    class="w-full text-left transition-colors hover:bg-n-alpha-1"
    @click="onClickViewDetails"
  >
    <div class="px-4 py-3" :class="COMPANY_ROW_GRID">
      <div class="flex items-center min-w-0 gap-2.5">
        <Avatar
          :username="displayName"
          :src="avatarSource"
          class="shrink-0"
          :name="displayName"
          :size="32"
          hide-offline-status
        />
        <div class="flex flex-col min-w-0">
          <span
            class="text-sm font-medium truncate text-n-slate-12"
            :title="displayName"
          >
            {{ displayName }}
          </span>
          <span
            v-if="domain"
            class="text-xs truncate text-n-slate-10"
            :title="domain"
          >
            {{ domain }}
          </span>
        </div>
      </div>

      <span class="text-sm truncate text-n-slate-11">
        {{ contactsCountLabel }}
      </span>

      <span class="text-sm truncate text-n-slate-11">
        {{ formattedLastActivityAt || '—' }}
      </span>

      <span class="text-sm truncate text-n-slate-11">
        {{ formattedCreatedAt || '—' }}
      </span>
    </div>
  </button>
</template>
